export class Seguro {
  id: number;
  descricao: string;
  percentual: number;
  obgAte: number;
  manualAPartirDe: number;
  msg: string;
  link: string;
  valor?: number;
  ativo: boolean;
  preSelecionado: boolean;
  apareceAvulso: boolean;
  apareceLojaProduto: boolean;
  valorMinimo: number;
}
